import angular from 'angular'

import component from './products.component'

let module = angular.module('products', [])

.component('products', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/products/index.js